import * as React from 'react'
import {compose} from 'redux'
import { Theme, createStyles, WithStyles, withStyles, Grid } from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import IndexMiniChart from 'src/page/Consumer/MarketIndicators/IndexMiniChart'
import {MARKET_INDICATORS_CONFIGS} from 'src/page/Consumer/MarketIndicators/IndexConfigs'

const styles = (t: Theme) => createStyles({
    tableWpr: {
        paddingTop: t.spacing.unit,
        width: '100%',
    },
});

interface IProps extends WithStyles<typeof styles>,
    WithI18n{
    type: string;
}

class IndexTab extends React.Component<IProps, any>{

    render() {
        const {classes, type} = this.props;
        return (
            <div className={classes.tableWpr}>
                <Grid container>
                    {MARKET_INDICATORS_CONFIGS[type].mini_chart.map(config => <Grid item md={4} key={`mini-chart-${config.index}`}><IndexMiniChart key={config.index} {...{config}} /></Grid>)}
                    {MARKET_INDICATORS_CONFIGS[type].index_table.map(config => <Grid item xs={12} key={`index-table-${config.index}`}><IndexMiniChart key={config.index} {...{config}} /></Grid>)}
                </Grid>
            </div>
        )
    }
};

export default compose(
    withI18n,
    withStyles(styles)
)(IndexTab)



// WEBPACK FOOTER //
// ./src/page/Consumer/MarketIndicators/IndexTab.tsx